import { withInstall } from '@lit-element/utils'
import Captcha from './src/captcha.vue'
import captchaSlider from './src/captcha-slider.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtCaptcha: SFCWithInstall<typeof Captcha> = withInstall(Captcha)
export default LtCaptcha

export const LtCaptchaSlider: SFCWithInstall<typeof captchaSlider> =
  withInstall(captchaSlider)

export type CaptchaInstance = InstanceType<typeof Captcha>
export type CaptchaSliderInstance = InstanceType<typeof captchaSlider>
